var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDm = function SvgDm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M14.349 23.77a12.013 12.013 0 0 0 9.421-9.423H14.35v9.422ZM.23 14.347a12.013 12.013 0 0 0 9.422 9.422v-9.422H.23ZM23.77 9.652A12.013 12.013 0 0 0 14.35.23v9.422h9.421ZM9.652.23A12.013 12.013 0 0 0 .23 9.652h9.422V.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M11.217 14.348H9.652v9.422c.511.101 1.034.17 1.566.204v-9.626ZM11.217 9.653V.027C10.686.06 10.163.13 9.652.23v9.422h1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.782.027a12.122 12.122 0 0 0-1.565 0v9.626h1.565V.027ZM11.217 23.974a12.074 12.074 0 0 0 1.565 0v-9.626h-1.565v9.626Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M9.652 11.218V9.653H.231c-.102.51-.17 1.033-.205 1.565h9.626ZM14.349 11.218h9.626a12.004 12.004 0 0 0-.204-1.565h-9.422v1.565Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.348 12.783h9.626a12.222 12.222 0 0 0 0-1.565h-9.626v1.565ZM.026 11.218a12.155 12.155 0 0 0 0 1.565h9.626v-1.565H.026Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 17.739A5.74 5.74 0 1 0 12 6.26a5.74 5.74 0 0 0 0 11.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M13.307 12.64c-.426-.853-.981-1.718-.981-1.718s.013-.394.013-.629a.64.64 0 0 0-1.277-.055.505.505 0 0 0-.2.951.727.727 0 0 1 .431-.401c.032.026.066.05.102.069l.082.039s-.304.857-.304 1.318c0 1.295.854 1.694.854 1.694v.014l-.427.426h.854v-.853l.427.427c.003-.008.808-.518.426-1.281ZM12 7.304l.194.598h.628l-.508.37.194.598L12 8.5l-.509.37.194-.598-.508-.37h.628L12 7.304ZM9.24 8.202l.509.37.508-.37-.194.598.509.37h-.63l-.193.597-.195-.598h-.628l.508-.37-.194-.597ZM7.534 10.55h.629l.194-.599.194.598h.629l-.509.37.195.598-.509-.37-.509.37.195-.598-.509-.37ZM7.534 13.451l.509-.37-.195-.597.509.37.509-.37-.195.598.509.37h-.629l-.194.597-.194-.598h-.629ZM9.24 15.799l.194-.598-.508-.37h.628l.195-.597.194.598h.629l-.509.37.194.597-.508-.37-.509.37ZM12 16.696l-.195-.597h-.628l.508-.37-.194-.598.509.37.508-.37-.194.598.508.37h-.628l-.194.597ZM14.76 15.799l-.508-.37-.509.37.194-.598-.508-.37h.628l.195-.597.194.598h.629l-.51.37.195.597ZM16.466 13.451h-.629l-.194.598-.194-.598h-.629l.509-.37-.194-.597.508.37.509-.37-.194.598.508.37ZM16.466 10.55l-.508.369.194.597-.509-.37-.508.37.194-.597-.509-.37h.629l.194-.598.194.598h.63ZM14.76 8.202l-.194.598.508.37h-.628l-.194.597-.195-.598h-.628l.508-.37-.194-.597.509.37.508-.37Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgDm;